import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CurrencyFilterSpec, Pageable, WrapperPageableResponse } from './service-common';

export interface CurrencyDTO {
  id: number;
  name: string;
  code: string;
}

export type WrapperPageableResponseCurrencyDTO = WrapperPageableResponse<CurrencyDTO>;

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  searchCurrencies(
    spec: CurrencyFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseCurrencyDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseCurrencyDTO>(
      `${this.apiUrl}/currencies`,
      { params }
    );
  }

  listCurrencies(
    spec: CurrencyFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseCurrencyDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseCurrencyDTO>(
      `${this.apiUrl}/currencies/list`,
      { params }
    );
  }
}
